import { Badge } from "../ui/badge";

export function StatusBadge({ status }) {
  const map = {
    ready: { cls: "bg-emerald-50 text-emerald-700 border-emerald-100", label: "Ready" },
    generating: { cls: "bg-amber-50 text-amber-700 border-amber-100", label: "Generating..." },
    failed: { cls: "bg-red-50 text-red-700 border-red-100", label: "Failed" },
    processing: { cls: "bg-blue-50 text-blue-700 border-blue-100", label: "Processing..." },
  };
  const s = map[status] || { cls: "bg-[#F3F3F9] text-[#94969C] border-[#E2E4E7]", label: "Not Started" };
  return <Badge className={`text-xs ${s.cls}`}>{s.label}</Badge>;
}
